export default __webpack_public_path__ + "static/media/MTSLA-UST.0e8a97ce.svg";